import React, { useEffect, useState } from "react";
import Layout from "@/components/layout/Layout";
import Spinner from "@/components/ui/Spinner";
import { useShallow } from "zustand/react/shallow";
import useRoleStore from "./store/rolesStore";
import useGlobalStore from "@/store/globalStore";
import { useNavigate } from "react-router-dom";

const ManageRoles: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);

  const { roles, getRoles, setRole } = useRoleStore(
    useShallow(({ roles, getRoles, setRole }) => ({ roles, getRoles, setRole }))
  );
  const setError = useGlobalStore((state) => state.setError);
  const navigate = useNavigate();

  const fetchRoles = async () => {
    setIsLoading(true);
    try {
      await getRoles();
    } catch (error) {
      setError(error instanceof Error ? error.message : "Unknown error");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchRoles();
  }, []);

  const handleRoleClick = (roleId: string, roleName: string) => {
    const role = roles.find((r) => r.id === roleId);
    if (role) {
      setRole(role);
      navigate(`/roles/permissions?id=${roleId}`);
    } else {
      setError(`Role "${roleName}" not found.`);
    }
  };

  return (
    <Layout>
      <div>
        <h1 className="text-2xl font-bold mb-8">Manage Roles</h1>

        <section>
          <h2 className="font-semibold text-xl mb-2">Edit Permissions</h2>
          <div className="border-t border-[#EA33C0]" />

          {isLoading && (
            <div className="flex justify-center mt-5 h-screen">
              <Spinner />
            </div>
          )}

          {!isLoading && roles.length === 0 && (
            <div className="mt-5 text-center">No Roles Found</div>
          )}

          {!isLoading &&
            roles.map((role) => (
              <div
                key={role.id}
                className="my-5 cursor-pointer"
                onClick={() => handleRoleClick(role.id, role.name)}
              >
                <div>{role.name}</div>
                <div className="border-t border-gray-300 mt-2" />
              </div>
            ))}
        </section>
      </div>
    </Layout>
  );
};

export default ManageRoles;
